import { Component, Input } from '@angular/core';
import { FactFindStatus } from '../../../fact-find/services/fact-find-api.service';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hfc-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss']
})
export class DesktopHeaderComponent {
  @Input()
  logoutButton = true;

  @Input()
  showProgressBar: boolean;

  @Input()
  percentageCompleted: number;

  constructor(public readonly tenantConfigService: TenantConfigService) {}
}
